const colors = [
  {
    name: 'white',
    label: 'White',
    style: {
      '--color-primary': '#ffffff',
      '--class': 'white',
    },
  },
  {
    name: 'red',
    label: 'Red',
    style: {
      '--color-primary': '#aa001e',
      '--class': 'red',
    },
  },
  {
    name: 'light-grey',
    label: 'Light Grey',
    style: {
      '--color-primary': '#acacac',
      '--class': 'light-grey',
    },
  },
  {
    name: 'grey',
    label: 'Grey',
    style: {
      '--color-primary': '#575556',
      '--class': 'grey',
    },
  },
];

export function GridSchema(props) {
  const schema = {
    title: 'Schema',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['color', 'link', 'autor', 'autor_funktion'],
      },
    ],

    properties: {
      color: {
        title: 'Farbe',
        type: 'string',
        widget: 'color_picker',
        colors: colors,
      },
      link: {
        title: 'Link auf',
        type: 'string',
      },
      autor: {
        title: 'Autor',
        type: 'string',
      },
      autor_funktion: {
        title: 'Autor Funktion',
        type: 'string',
      },
    },
    required: [],
  };
  return schema;
}

export default GridSchema;
